import fetchWith403Redirect from './fetchWith403Redirect';
import { API_URL as API_BASE } from '../config/env';

const API_URL = `${API_BASE}/api/rates`;

async function readJsonOrThrow(res) {
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(body?.message || `Request failed (${res.status})`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function getRates() {
  const res = await fetchWith403Redirect(API_URL, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
  return readJsonOrThrow(res);
}

export async function addRate(rate) {
  const res = await fetchWith403Redirect(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify(rate),
  });
  return readJsonOrThrow(res);
}

export async function updateRate(id, rate) {
  const res = await fetchWith403Redirect(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
    body: JSON.stringify(rate),
  });
  return readJsonOrThrow(res);
}

export async function deleteRate(id) {
  const res = await fetchWith403Redirect(`${API_URL}/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  });
  return readJsonOrThrow(res);
}
